module.exports = require("base-58");